import React from 'react'

export const PickupMarker = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#clip0_3141_19908)">
      <path
        opacity="0.2"
        d="M15.835 40.0387C10.6309 20.9295 9.23275 18.6554 11.2205 13.0091C12.5285 9.29366 15.2589 6.24999 18.811 4.54767C22.3631 2.84536 26.446 2.62383 30.1614 3.93184C33.8769 5.23984 36.9206 7.97023 38.6229 11.5223C40.3252 15.0745 40.5467 19.1573 39.2387 22.8728C37.251 28.5191 34.7273 29.4125 18.7091 41.0506C18.4662 41.2251 18.1847 41.3385 17.8885 41.3809C17.5924 41.4233 17.2904 41.3936 17.0082 41.2942C16.726 41.1949 16.472 41.0289 16.2677 40.8103C16.0635 40.5917 15.915 40.327 15.835 40.0387Z"
        fill="black"
      />
      <path
        d="M15.56 40.49C4.11 23.91 2 22.2 2 16.11C2 12.1026 3.59194 8.25929 6.42562 5.42562C9.25929 2.59194 13.1026 1 17.11 1C21.1174 1 24.9607 2.59194 27.7944 5.42562C30.6281 8.25929 32.22 12.1026 32.22 16.11C32.22 22.2 30.1 23.91 18.66 40.49C18.4858 40.7396 18.254 40.9435 17.9841 41.0842C17.7142 41.225 17.4144 41.2985 17.11 41.2985C16.8056 41.2985 16.5058 41.225 16.2359 41.0842C15.966 40.9435 15.7342 40.7396 15.56 40.49Z"
        fill="#A3A3A3"
      />
      <circle cx="17" cy="16" r="11" fill="white" />
      <g clipPath="url(#clip1_3141_19908)">
        <path
          d="M22.25 23L11.75 23C11.3344 23 11 22.6656 11 22.25L11 21.5C11 21.0844 11.3344 20.75 11.75 20.75L22.25 20.75C22.6656 20.75 23 21.0844 23 21.5L23 22.25C23 22.6656 22.6656 23 22.25 23ZM19 19.25L19 15L21.7406 15C22.2969 15 22.575 14.3281 22.1813 13.9344L17.425 9.17812C17.1906 8.94375 16.8063 8.94375 16.5719 9.17812L11.8156 13.9344C11.4219 14.3281 11.7 15 12.2563 15L15 15L15 19.25C15 19.6656 15.3344 20 15.75 20L18.25 20C18.6656 20 19 19.6656 19 19.25Z"
          fill="#A3A3A3"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_3141_19908">
        <rect width="42" height="42" fill="white" />
      </clipPath>
      <clipPath id="clip1_3141_19908">
        <rect width="12" height="16" fill="white" transform="translate(23 24) rotate(-180)" />
      </clipPath>
    </defs>
  </svg>
)

export const DeliveredMarker = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#clip0_3141_19903)">
      <path
        opacity="0.2"
        d="M16.835 40.0387C11.6309 20.9295 10.2328 18.6554 12.2205 13.0091C13.5285 9.29366 16.2589 6.24999 19.811 4.54767C23.3631 2.84536 27.446 2.62383 31.1614 3.93184C34.8769 5.23984 37.9206 7.97023 39.6229 11.5223C41.3252 15.0745 41.5467 19.1573 40.2387 22.8728C38.251 28.5191 35.7273 29.4125 19.7091 41.0506C19.4662 41.2251 19.1847 41.3385 18.8885 41.3809C18.5924 41.4233 18.2904 41.3936 18.0082 41.2942C17.726 41.1949 17.472 41.0289 17.2677 40.8103C17.0635 40.5917 16.915 40.327 16.835 40.0387Z"
        fill="black"
      />
      <path
        d="M16.56 40.49C5.11 23.91 3 22.2 3 16.11C3 12.1026 4.59194 8.25929 7.42562 5.42562C10.2593 2.59194 14.1026 1 18.11 1C22.1174 1 25.9607 2.59194 28.7944 5.42562C31.6281 8.25929 33.22 12.1026 33.22 16.11C33.22 22.2 31.1 23.91 19.66 40.49C19.4858 40.7396 19.254 40.9435 18.9841 41.0842C18.7142 41.225 18.4144 41.2985 18.11 41.2985C17.8056 41.2985 17.5058 41.225 17.2359 41.0842C16.966 40.9435 16.7342 40.7396 16.56 40.49Z"
        fill="#15803D"
      />
      <path
        d="M29 16C29 22.0751 24.0751 27 18 27C11.9249 27 7 22.0751 7 16C7 9.92485 11.9249 5 18 5C24.0751 5 29 9.92485 29 16ZM16.7276 21.8244L24.8889 13.6631C25.1661 13.386 25.1661 12.9366 24.8889 12.6595L23.8853 11.6559C23.6082 11.3787 23.1588 11.3787 22.8816 11.6559L16.2258 18.3117L13.1184 15.2042C12.8412 14.9271 12.3919 14.9271 12.1147 15.2042L11.1111 16.2078C10.8339 16.485 10.8339 16.9343 11.1111 17.2115L15.724 21.8244C16.0011 22.1015 16.4505 22.1015 16.7276 21.8244Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_3141_19903">
        <rect width="42" height="42" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

export const DeliveryMarker = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#clip0_3141_19915)">
      <path
        opacity="0.2"
        d="M15.835 40.0387C10.6309 20.9295 9.23275 18.6554 11.2205 13.0091C12.5285 9.29366 15.2589 6.24999 18.811 4.54767C22.3631 2.84536 26.446 2.62383 30.1614 3.93184C33.8769 5.23984 36.9206 7.97023 38.6229 11.5223C40.3252 15.0745 40.5467 19.1573 39.2387 22.8728C37.251 28.5191 34.7273 29.4125 18.7091 41.0506C18.4662 41.2251 18.1847 41.3385 17.8885 41.3809C17.5924 41.4233 17.2904 41.3936 17.0082 41.2942C16.726 41.1949 16.472 41.0289 16.2677 40.8103C16.0635 40.5917 15.915 40.327 15.835 40.0387Z"
        fill="#171717"
      />
      <path
        d="M15.56 40.49C4.11 23.91 2 22.2 2 16.11C2 12.1026 3.59194 8.25929 6.42562 5.42562C9.25929 2.59194 13.1026 1 17.11 1C21.1174 1 24.9607 2.59194 27.7944 5.42562C30.6281 8.25929 32.22 12.1026 32.22 16.11C32.22 22.2 30.1 23.91 18.66 40.49C18.4858 40.7396 18.254 40.9435 17.9841 41.0842C17.7142 41.225 17.4144 41.2985 17.11 41.2985C16.8056 41.2985 16.5058 41.225 16.2359 41.0842C15.966 40.9435 15.7342 40.7396 15.56 40.49Z"
        fill="#171717"
      />
      <circle cx="17" cy="16" r="11" fill="white" />
      <path
        d="M22.25 23H11.75C11.3344 23 11 22.6656 11 22.25V21.5C11 21.0844 11.3344 20.75 11.75 20.75H22.25C22.6656 20.75 23 21.0844 23 21.5V22.25C23 22.6656 22.6656 23 22.25 23ZM15 9.75V14H12.2594C11.7031 14 11.425 14.6719 11.8188 15.0656L16.575 19.8219C16.8094 20.0563 17.1937 20.0563 17.4281 19.8219L22.1844 15.0656C22.5781 14.6719 22.3 14 21.7437 14H19V9.75C19 9.33438 18.6656 9 18.25 9H15.75C15.3344 9 15 9.33438 15 9.75Z"
        fill="#171717"
      />
    </g>
    <defs>
      <clipPath id="clip0_3141_19915">
        <rect width="42" height="42" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

export const DeviationMarker = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#clip0_3141_19898)">
      <path
        opacity="0.2"
        d="M15.835 40.0387C10.6309 20.9295 9.23275 18.6554 11.2205 13.0091C12.5285 9.29366 15.2589 6.24999 18.811 4.54767C22.3631 2.84536 26.446 2.62383 30.1614 3.93184C33.8769 5.23984 36.9206 7.97023 38.6229 11.5223C40.3252 15.0745 40.5467 19.1573 39.2387 22.8728C37.251 28.5191 34.7273 29.4125 18.7091 41.0506C18.4662 41.2251 18.1847 41.3385 17.8885 41.3809C17.5924 41.4233 17.2904 41.3936 17.0082 41.2942C16.726 41.1949 16.472 41.0289 16.2677 40.8103C16.0635 40.5917 15.915 40.327 15.835 40.0387Z"
        fill="black"
      />
      <path
        d="M15.56 40.49C4.11 23.91 2 22.2 2 16.11C2 12.1026 3.59194 8.25929 6.42562 5.42562C9.25929 2.59194 13.1026 1 17.11 1C21.1174 1 24.9607 2.59194 27.7944 5.42562C30.6281 8.25929 32.22 12.1026 32.22 16.11C32.22 22.2 30.1 23.91 18.66 40.49C18.4858 40.7396 18.254 40.9435 17.9841 41.0842C17.7142 41.225 17.4144 41.2985 17.11 41.2985C16.8056 41.2985 16.5058 41.225 16.2359 41.0842C15.966 40.9435 15.7342 40.7396 15.56 40.49Z"
        fill="#B91C1C"
      />
      <g clipPath="url(#clip1_3141_19898)">
        <path
          d="M26.7749 20.6098C27.4158 21.6721 26.6113 23 25.3313 23H8.66855C7.38602 23 6.58525 21.67 7.22491 20.6098L15.5564 6.79638C16.1976 5.73358 17.8036 5.7355 18.4437 6.79638L26.7749 20.6098ZM17 17.7539C16.1179 17.7539 15.4028 18.4377 15.4028 19.2812C15.4028 20.1248 16.1179 20.8086 17 20.8086C17.8821 20.8086 18.5972 20.1248 18.5972 19.2812C18.5972 18.4377 17.8821 17.7539 17 17.7539ZM15.4836 12.2639L15.7412 16.7795C15.7532 16.9908 15.9359 17.1562 16.1572 17.1562H17.8428C18.0641 17.1562 18.2468 16.9908 18.2589 16.7795L18.5164 12.2639C18.5295 12.0357 18.3394 11.8437 18.1004 11.8437H15.8996C15.6606 11.8437 15.4706 12.0357 15.4836 12.2639Z"
          fill="#FEF2F2"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_3141_19898">
        <rect width="42" height="42" fill="white" />
      </clipPath>
      <clipPath id="clip1_3141_19898">
        <rect width="20" height="17" fill="white" transform="translate(7 6)" />
      </clipPath>
    </defs>
  </svg>
)

export const ReturnedMarker = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#clip0_3141_19915)">
      <path
        opacity="0.2"
        d="M15.835 40.0387C10.6309 20.9295 9.23275 18.6554 11.2205 13.0091C12.5285 9.29366 15.2589 6.24999 18.811 4.54767C22.3631 2.84536 26.446 2.62383 30.1614 3.93184C33.8769 5.23984 36.9206 7.97023 38.6229 11.5223C40.3252 15.0745 40.5467 19.1573 39.2387 22.8728C37.251 28.5191 34.7273 29.4125 18.7091 41.0506C18.4662 41.2251 18.1847 41.3385 17.8885 41.3809C17.5924 41.4233 17.2904 41.3936 17.0082 41.2942C16.726 41.1949 16.472 41.0289 16.2677 40.8103C16.0635 40.5917 15.915 40.327 15.835 40.0387Z"
        fill="#c2410c"
      />
      <path
        d="M15.56 40.49C4.11 23.91 2 22.2 2 16.11C2 12.1026 3.59194 8.25929 6.42562 5.42562C9.25929 2.59194 13.1026 1 17.11 1C21.1174 1 24.9607 2.59194 27.7944 5.42562C30.6281 8.25929 32.22 12.1026 32.22 16.11C32.22 22.2 30.1 23.91 18.66 40.49C18.4858 40.7396 18.254 40.9435 17.9841 41.0842C17.7142 41.225 17.4144 41.2985 17.11 41.2985C16.8056 41.2985 16.5058 41.225 16.2359 41.0842C15.966 40.9435 15.7342 40.7396 15.56 40.49Z"
        fill="#c2410c"
      />
      <circle cx="17" cy="16" r="11" fill="white" />
      <path
        d="M22.25 23H11.75C11.3344 23 11 22.6656 11 22.25V21.5C11 21.0844 11.3344 20.75 11.75 20.75H22.25C22.6656 20.75 23 21.0844 23 21.5V22.25C23 22.6656 22.6656 23 22.25 23ZM15 9.75V14H12.2594C11.7031 14 11.425 14.6719 11.8188 15.0656L16.575 19.8219C16.8094 20.0563 17.1937 20.0563 17.4281 19.8219L22.1844 15.0656C22.5781 14.6719 22.3 14 21.7437 14H19V9.75C19 9.33438 18.6656 9 18.25 9H15.75C15.3344 9 15 9.33438 15 9.75Z"
        fill="#c2410c"
      />
    </g>
    <defs>
      <clipPath id="clip0_3141_19915">
        <rect width="42" height="42" fill="white" />
      </clipPath>
    </defs>
  </svg>
)
